import React, {useState} from "react";
import CircleImage from "olive-react-myoneui/lib/CircleImage";
import Button from "olive-react-myoneui/lib/Button";
import { closeIcon, speakerIcon } from "../../../constants/icons";


const NOTIFICATION_STORAGE_KEY = "dashboardNotificationDismissed";

const DashboardNotification = ({ id, className, iconDashNotification, titleDashNotification, descDashNotification, helperDashNotification, onClose }) => {
    const [isVisible, setIsVisible] = useState(() => {
        const storedData = localStorage.getItem(NOTIFICATION_STORAGE_KEY);
        const dismissedNotifications = storedData ? JSON.parse(storedData) : [];

        return Array.isArray(dismissedNotifications) ? !dismissedNotifications.includes(id) : true;
    });

    const handleClose = () => {
        setIsVisible(false);

        // Store dismissed notification ID in localStorage
        const storedData = localStorage.getItem(NOTIFICATION_STORAGE_KEY);
        const dismissedNotifications = storedData ? JSON.parse(storedData) : [];
        const updatedDismissed = Array.isArray(dismissedNotifications) ? [...dismissedNotifications, id] : [id];

        localStorage.setItem(NOTIFICATION_STORAGE_KEY, JSON.stringify(updatedDismissed));

        // Notify Dashboard to update container height
        if (onClose) {
            onClose(id);
        }
    };

    if (!isVisible) return null; // Hide notification if dismissed

    return (
        <>
        <div className={`${className || ""} dashboard-notification-wrapper`}>
            <div className="information-block mb-0">
                <div className="information-wrap">
                    <div className="information-holder">
                        <CircleImage className="circle-wrap circle-wrap-md bg-white">
                        {iconDashNotification ?  iconDashNotification : speakerIcon}
                        </CircleImage>
                        <div className="information-detail">
                            {titleDashNotification && <h4>{titleDashNotification}</h4>}
                            {descDashNotification && <p dangerouslySetInnerHTML={{ __html: descDashNotification }} />}
                            {helperDashNotification && <span>{helperDashNotification}</span>}
                        </div>
                    </div>
                    <Button
                        variant="primary"
                        type="button"
                        size="sm"
                        className="btn-round bg-primary-fade"
                        aria-label="Close"
                        onClick={handleClose}
                        >
                        {closeIcon}
                    </Button>
                </div>
            </div>
        </div>
        </>
    );
};

export default DashboardNotification;
